import { useTranslation } from 'react-i18next'
import { Play } from 'lucide-react'
import { Dialog, DialogContent } from '../ui/dialog'
import { Button } from '../ui/button'
import { useTimerStore } from '../../stores/timer-store'
import { primeAudio } from '../../utils/timer-audio'
import { TimerHeader } from './TimerHeader'
import { TimerStage } from './TimerStage'
import { TimerNavControls } from './TimerNavControls'
import { TimerSetList } from './TimerSetList'
import { ArmedPreview } from './ArmedPreview'

export function WorkoutTimerDialog() {
  const { t } = useTranslation()
  const dialogOpen = useTimerStore((s) => s.dialogOpen)
  const phase = useTimerStore((s) => s.phase)
  const closeDialog = useTimerStore((s) => s.closeDialog)
  const openEndModal = useTimerStore((s) => s.openEndModal)
  const startTimer = useTimerStore((s) => s.startTimer)

  const visible = dialogOpen && phase !== 'idle'

  function handleStart() {
    primeAudio()
    startTimer()
  }

  return (
    <Dialog open={visible} onOpenChange={(o) => { if (!o) closeDialog() }}>
      <DialogContent className="max-w-md">
        <div className="flex flex-col gap-4">
          <TimerHeader />
          {phase === 'armed' ? (
            <ArmedPreview />
          ) : (
            <>
              <TimerStage />
              <TimerNavControls />
              <div className="border-t pt-2 max-h-72 overflow-y-auto">
                <TimerSetList />
              </div>
              <Button type="button" variant="outline" onClick={openEndModal}>
                {t('workoutTimer.endButton', 'End workout')}
              </Button>
            </>
          )}
          {phase === 'armed' && (
            <Button type="button" size="lg" onClick={handleStart}>
              <Play className="size-5 mr-1" />
              {t('workoutTimer.armed.start', 'Start')}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
